<div class="p-d-inline-flex" *ngIf="vezaniRacuni && vezaniRacuni.length > 0">
  <label style="line-height: 20px;">Veza:</label>
  <div class="kodit-chip-container p-ml-2" style="display: flex; width: 40vw; flex-wrap: wrap;" card-body>
    <ng-container>
      <div
        class="p-mr-2 my-p-chip"
        *ngFor="let x of vezaniRacuni; index as i"
      >
        <ng-container>
          <div>
            <button
              pButton
              type="button"
              [label]="x.label"
              class="p-button-link"
              style="padding: 2px;"
              pTooltip="Prikaži račun"
              tooltipPosition="bottom"
              (click)="handleGoToRacun(x)"
            ></button>
          </div>
          <span
            class="fa-solid fa-xmark my-p-chip-remove-icon p-button-danger"
            pTooltip="Ukloni oznaku iz računa"
            tooltipPosition="bottom"
            (click)="handleRemoveRacun(i)"
          ></span>
        </ng-container>
      </div>
    </ng-container>
  </div>
</div>

<div class="p-d-inline-flex p-mt-2" *ngIf="eOtpremnice && eOtpremnice.length > 0">
  <label style="line-height: 20px;">eOtpremnice:</label>
  <div class="kodit-chip-container p-ml-2" style="display: flex; width: 40vw; flex-wrap: wrap;" card-body>
    <div class="p-mr-2 my-p-chip" *ngFor="let x of eOtpremnice; index as i">
      <div>
        <span style="padding: 2px; line-height: 20px;">{{ x.label }}</span>
      </div>
      <!-- eOtpremnica kreirana iz predracuna se ne razvezuje -->
      <span
        *ngIf="racunTip !== tipPredracun"
        class="fa-solid fa-xmark my-p-chip-remove-icon p-button-danger"
        pTooltip="Razvezi eOtpremnicu od računa"
        tooltipPosition="bottom"
        (click)="handleRemoveEOtpremnica(x.id, i)"
      ></span>
    </div>
  </div>
</div>

<div class="p-d-inline-flex p-mt-2" *ngIf="ePrijemnice && ePrijemnice.length > 0">
  <label style="line-height: 20px;">ePrijemnice:</label>
  <div class="kodit-chip-container p-ml-2" style="display: flex; width: 40vw; flex-wrap: wrap;" card-body>
    <div class="p-mr-2 my-p-chip" *ngFor="let x of ePrijemnice; index as i">
      <div>
        <span style="padding: 2px; line-height: 20px;">{{ x.label }}</span>
      </div>
      <span
        class="fa-solid fa-xmark my-p-chip-remove-icon p-button-danger"
        pTooltip="Razvezi ePrijemnicu od računa"
        tooltipPosition="bottom"
        (click)="handleRemoveEOtpremnica(x.id, i, true)"
      ></span>
    </div>
  </div>
</div>
